import RouteView from '@/layouts/RouteView'
import ManageLayout from '@/layouts/ManageLayout.vue'

const defaultRoutes = [
  {
    name: 'user',
    path: '/user',
    component: RouteView,
    redirect: '/user/login',
    children: [
      {
        name: 'login',
        path: '/user/login',
        component: () => import('@/views/user/login')
      },
      {
        name: 'caserror',
        path: '/user/caserror',
        component: () => import('@/views/user/caserror')
      },
      {
        name: 'cassuccess',
        path: '/user/cassuccess',
        component: () => import('@/views/user/cassuccess')
      },
      // {
      //   name: 'dispatch',
      //   path: '/user/dispatch',
      //   component: () => import('@/views/user/dispatch')
      // },
    ]
  },
  {
    name: 'appConfig',
    path: '/app/config',
    component: ManageLayout,
    children: [
      {
        name: 'pageConfig',
        path: '/app/config/page',
        component: () => import('@/views/app/PageConfig')
      },
      {
        name: 'pageReview',
        path: '/app/review/page',
        component: () => import('@/views/app/PageReview')
      },
      {
        // 兼容页面设计平台
        name: 'pageDesignRedirect',
        path: '/project/page/single',
        redirect: '/app/review/page',
        component: () => import('@/views/app/PageReview')
      }
    ]
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/exceptions/404')
  }
]

export {
  defaultRoutes
}